import React from 'react';
import { Pressable } from 'react-native';
import { Avatar, Text } from '@rneui/themed';
import { useJWT } from '@annunciate/core';
export const AccountButton = ({ onPress }) => {
    const jwt = useJWT();
    let initials;
    let image;
    if (jwt) {
        const i = [
            jwt.given_name ? jwt.given_name[0] : undefined,
            jwt.family_name ? jwt.family_name[0] : undefined,
        ].filter(e => !!e);
        initials = i.join('');
        image = jwt.picture;
    }
    else {
        return React.createElement(Text, { onPress: onPress }, "Account");
    }
    return (React.createElement(Pressable, { onPress: onPress },
        React.createElement(Avatar, { rounded: true, size: 38, title: image ? undefined : initials, source: image ? { uri: image } : undefined })));
};
//# sourceMappingURL=AccountButton.js.map